import { SandboxError } from "./sandbox-error";
import { SandboxErrorCode } from "./sandbox-error-code.enum";

export class SandboxPortfolioSetError extends SandboxError {
    code = SandboxErrorCode.PortfolioSet;
}
